module.exports = __webpack_public_path__ + "static/media/201ME110.55db62d6.jpg";